<template>
  <div class="dialog-list">
    <div class="dialog-list">
      <div
        class="item"
        v-for="(q, i) in qaList"
        :key="i"
        style="margin-bottom: 20px"
        v-show="i < count"
      >
        <p style="margin-bottom: 10px">
          <strong>{{ ++i }}、{{ q.question }}</strong>
        </p>
        <template v-if="q.option.length > 0">
          <el-tag
            v-for="(a, j) in q.option"
            :key="j"
            effect="plain"
            style="margin-right: 6px"
          >
            {{ a }}
          </el-tag></template
        >
      </div>
      <div
        style="
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-size: 30px;
          color: #999;
          text-align: center;
        "
        v-if="showMore"
      >
        <i
          class="el-icon-d-arrow-right"
          style="cursor: pointer; transform: rotate(90deg)"
          @click="showAll()"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "eva",
  data() {
    return {
      showMore: true,
      qaList: [],
      count: 0,
    };
  },
  mounted() {
    this.showDetail();
  },
  methods: {
    showAll() {
      this.showMore = false;
      this.count = this.qaList.length;
    },
    /**
     * 显示弹窗
     */
    showDetail(row) {
      this.dialogVisible = true;
      // 请求
      this.getDetail(row);
    },

    /**
     * 获取订单详情
     */
    async getDetail() {
      let res = await this.axios.get(this.getApiUrl("qaAll"), {
        params: { qnId: "2122010001001" },
      });

      if (res.code === 1) {
        this.qaList = res.data;
      }
      // this.qaList = [
      //   {
      //     question: "您的性别是？",
      //     answer: ["男"],
      //   },
      //   {
      //     question: "请问您的生日是？",
      //     answer: ["1984-6-15"],
      //   },
      //   {
      //     question: "首先，让我先了解一下您的基本信息吧~",
      //     answer: ["好的"],
      //   },
      //   {
      //     question: "您的性别是？",
      //     answer: ["男"],
      //   },
      //   {
      //     question: "首先，让我先了解一下您的基本信息吧~",
      //     answer: ["好的"],
      //   },
      //   {
      //     question: "请问您的生日是？",
      //     answer: ["1984-6-15"],
      //   },
      //   {
      //     question: "首先，让我先了解一下您的基本信息吧~",
      //     answer: ["好的"],
      //   },
      //   {
      //     question: "您的性别是？",
      //     answer: ["男"],
      //   },
      //   {
      //     question: "请问您的生日是？",
      //     answer: ["1984-6-15"],
      //   },
      //   {
      //     question: "首先，让我先了解一下您的基本信息吧~",
      //     answer: ["好的"],
      //   },
      //   {
      //     question: "您的性别是？",
      //     answer: ["男"],
      //   },
      //   {
      //     question: "请问您的生日是？",
      //     answer: ["1984-6-15"],
      //   },
      // ];
      if (this.qaList.length > 10) {
        this.showMore = true;
        this.count = 10;
      } else {
        this.showMore = false;
        this.count = this.qaList.length;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
  .title {
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
    font-weight: bold;
    padding-left: 20px;
    margin-top: 18px;
    position: relative;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 8px;
      background-color: $theme;
    }
  }
}
</style>
